import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { SubscriberCommunicationPreferencesDto } from 'enrollment/queries';
import { Spacer, LabelValuePair } from 'theSource/components';
import {
  EmailContainerStyled,
  EmailInputContainerStyled,
  LabelValuePairStyled,
  EditButtonWrapperStyled,
  AddEmailContainerStyled,
} from '../../CommunicationPreferencesStyled';

interface EditEmailAddressesProps {
  preferences: SubscriberCommunicationPreferencesDto | undefined;
  editEmail: boolean;
  setEditEmail: Dispatch<SetStateAction<boolean>>;
  emailsPresent: string | undefined;
  addEmail: boolean;
  setAddEmail: Dispatch<SetStateAction<boolean>>;
}

export const EditEmailAddresses = ({
  preferences,
  editEmail,
  setEditEmail,
  emailsPresent,
  addEmail,
  setAddEmail,
}: EditEmailAddressesProps) => {
  const { t } = useTranslation('pages.communicationPreferencesLumos');

  return (
    <>
      <EmailContainerStyled>
        <EmailInputContainerStyled>
          {editEmail || !emailsPresent ? (
            <>
              <ps-text-field
                input-id="email_1"
                label={t('email1Label')}
                value={preferences?.email_1}
                data-testid="edit-email1"
              ></ps-text-field>
              <ps-text-field
                input-id="email_2"
                label={t('email2Label')}
                value={preferences?.email_2}
                data-testid="edit-email2"
              ></ps-text-field>
            </>
          ) : (
            <>
              <LabelValuePairStyled>
                <Spacer height={4} />
                <LabelValuePair
                  key="email_1"
                  label={t('email1Label')}
                  value={preferences ? preferences.email_1 : ''}
                />
              </LabelValuePairStyled>
              <Spacer height={6} />
              <LabelValuePairStyled>
                <LabelValuePair
                  key="email_2"
                  label={t('email2Label')}
                  value={preferences ? preferences.email_2 : ''}
                />
              </LabelValuePairStyled>
            </>
          )}
        </EmailInputContainerStyled>
        {emailsPresent ? (
          <EditButtonWrapperStyled>
            <ps-button
              id="edit_email"
              label={editEmail ? t('cancel') : t('edit')}
              level="tertiary"
              icon="pencil-simple"
              onClick={() => setEditEmail(!editEmail)}
              data-testid="edit-email-button"
            ></ps-button>
          </EditButtonWrapperStyled>
        ) : null}
      </EmailContainerStyled>
      {addEmail || preferences?.email_3 ? (
        <AddEmailContainerStyled>
          <EmailInputContainerStyled>
            <ps-text-field
              input-id="email_3"
              label={t('email3Label')}
              value={preferences?.email_3}
              data-testid="edit-email3"
            ></ps-text-field>
            <ps-checkbox
              key="prefer_alt_email"
              input-id="prefer_alt_email"
              name="prefer_alt_email"
              label={t('preferredEmail')}
              checked={preferences?.prefer_alt_email ? '' : null}
            />
          </EmailInputContainerStyled>
          {!preferences?.email_3 ? (
            <EditButtonWrapperStyled>
              <ps-button
                id="remove_email"
                label="Cancel"
                level="tertiary"
                extra-class="cancel-btn"
                onClick={() => setAddEmail(!addEmail)}
                icon="trash"
              ></ps-button>
            </EditButtonWrapperStyled>
          ) : null}
        </AddEmailContainerStyled>
      ) : (
        <>
          <Spacer height={3} />
          <ps-button
            id="add_alt_email"
            label="Add Additional Email"
            level="tertiary"
            icon="plus"
            onClick={() => setAddEmail(!addEmail)}
            data-testid="add-alt-email-button"
          ></ps-button>
        </>
      )}
    </>
  );
};
